import { Slider } from '@/components/ui/slider';
import { FilterSection } from './FilterSection';

interface Props {
  min: number;
  max: number;
  /** Hard cap of the slider; values >= cap render as "${cap}+". */
  cap?: number;
  step?: number;
  onChange: (next: { min: number; max: number }) => void;
}

/**
 * Canonical Price range section for desktop filter trays.
 * Always a dual-thumb slider — no min/max number inputs.
 */
export function PriceRangeSection({ min, max, cap = 1000, step = 10, onChange }: Props) {
  const formatMax = max >= cap ? `$${cap}+` : `$${max}`;
  return (
    <FilterSection title="Price">
      <div className="px-2 pt-2" style={{ touchAction: 'none' }}>
        <Slider
          min={0}
          max={cap}
          step={step}
          value={[min, max]}
          onValueChange={(values) => onChange({ min: values[0], max: values[1] })}
          className="w-full"
        />
        <div className="flex justify-between text-xs text-muted-foreground/80 mt-2">
          <span>${min}</span>
          <span>{formatMax}</span>
        </div>
      </div>
    </FilterSection>
  );
}
